/* ===========================================================================
   Cart page behaviour
   ---------------------------------------------------------------------------
   Quantity steppers and remove links, applied without a page reload.

   Uses /cart/change.js addressed by LINE NUMBER rather than by variant id or
   line key. Two identical variants can legitimately occupy separate lines
   (different line-item properties, say), and addressing by id would then edit
   whichever one Shopify matched first. The line number is unambiguous.

   Deliberately NOT /cart/update.js: that endpoint replaces the fields it is
   given, and a partial payload drops the cart attributes — which is where
   ddc_cid and ddc_ref live. Losing those loses an affiliate's commission.
   ========================================================================= */
(function () {
  "use strict";

  var root = document.querySelector(".ddc-cart");
  var form = document.getElementById("CartForm");
  if (!root || !form) return;

  /* The no-JS update button is redundant now that the steppers are live, and
     leaving it visible invites a click that does nothing a shopper can see. */
  var update = root.querySelector(".ddc-cart__update");
  if (update) update.hidden = true;

  var busy = false;

  /* A visible, announced message for problems a shopper must know about —
     e.g. asking for more than is in stock. */
  var notice = document.createElement("p");
  notice.className = "ddc-cart__notice";
  notice.setAttribute("role", "status");
  notice.hidden = true;
  form.insertBefore(notice, form.firstChild);
  function say(text) {
    notice.textContent = text;
    notice.hidden = !text;
  }
  var remembered = (function () {
    try { return sessionStorage.getItem("ddc_cart_notice"); } catch (e) { return null; }
  })();
  if (remembered) {
    say(remembered);
    try { sessionStorage.removeItem("ddc_cart_notice"); } catch (e) {}
  }

  function setBusy(state) {
    busy = state;
    root.setAttribute("aria-busy", state ? "true" : "false");
  }

  function change(line, quantity) {
    if (busy) return;
    setBusy(true);
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (r) {
        /* 422: Shopify capped the line at what is in stock. It HAS changed the
           cart, so reload to show the truth, and carry the reason across the
           reload — previously the page kept showing 999 and a stale subtotal
           with no message (QA, 2026-09-14). */
        if (r.status === 422) {
          try {
            sessionStorage.setItem("ddc_cart_notice",
              "We don't have that many in stock right now, so we've added as many as we can.");
          } catch (e) {}
          window.location.reload();
          return;
        }
        if (!r.ok) throw new Error("cart change failed");
        /* A full reload rather than patching the DOM: the subtotal, any
           cart-level discounts and the line totals all move together, and
           re-rendering them by hand is how those drift out of step with what
           checkout will actually charge. */
        window.location.reload();
      })
      .catch(function () {
        setBusy(false);
        say("Couldn't update your cart. Please check your connection and try again.");
        /* Fall back to the native form, which still works. */
        if (update) update.hidden = false;
      });
  }

  root.addEventListener("click", function (e) {
    var stepBtn = e.target.closest(".ddc-cart__step");
    var removeBtn = e.target.closest("[data-remove]");
    if (!stepBtn && !removeBtn) return;

    var li = e.target.closest(".ddc-cart__line");
    if (!li) return;
    var line = parseInt(li.dataset.line, 10);

    if (removeBtn) {
      change(line, 0);
      return;
    }

    var input = li.querySelector(".ddc-cart__num");
    var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(stepBtn.dataset.step, 10));
    change(line, next);
  });

  /* Typing a quantity directly. `change` fires on blur or Enter, not on every
     keystroke, so a shopper typing "12" does not briefly request 1. */
  root.addEventListener("change", function (e) {
    var input = e.target.closest(".ddc-cart__num");
    if (!input) return;
    var li = input.closest(".ddc-cart__line");
    var value = parseInt(input.value, 10);
    /* Clearing the box to retype, then tapping away, used to delete the item.
       Only an explicit 0 (or the Remove link) removes; anything unreadable
       puts the previous quantity back. */
    if (isNaN(value) || value < 0) {
      input.value = input.defaultValue;
      return;
    }
    change(parseInt(li.dataset.line, 10), value);
  });

  root.addEventListener("keydown", function (e) {
    if (e.key !== "Enter") return;
    var input = e.target.closest(".ddc-cart__num");
    if (!input) return;
    // Otherwise Enter submits the form and reloads via the no-JS path.
    e.preventDefault();
    input.blur();
  });
})();
